import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";
import store from "../../redux/store/store";
import {apiLoading, error} from "../../redux/slice/apiSlice";
import {handleActiveError} from "../../components/sonner/ToastBasic";
import {apiRequest} from "../../components/Utils/SimmsUtils";


const selectServiceRequest = async (search, pageable) => {
    try {
        return await needAuth.post(`/serviceRequest?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getServiceRequest = async (data) => {
    try {
        return await needAuth.get(`/serviceRequest/${data.id}/${data.progressStatus}`)
    } catch (e) {
        if (e instanceof AxiosError) {
            const status = e.response.status;
            const data = e.response.data;
            if (status === 404) {
                store.dispatch(error({code:status}))
            }
            return {status, data}
        }
    } finally {
        store.dispatch(apiLoading(false));
    }
}

const saveServiceRequest = async (data, files, success) => {
    const formData = new FormData();
    files.forEach((file, index) => {formData.append(`files`, file.object);});
    formData.append("requestDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

    return apiRequest(() => needAuth.post(
        `/serviceRequest/create`, formData,
        {headers: {'Content-Type': 'multipart/form-data'}}), success);
}

const completePreRegisterWork = async (data, files, success) => {
    const formData = new FormData();
    files.forEach((file, index) => {formData.append(`files`, file.object);});
    formData.append("requestDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

    return apiRequest(() => needAuth.put(
        `/serviceRequest/preRegister`, formData,
        {headers: {'Content-Type': 'multipart/form-data'}}), success);
}

const updateServiceRequest = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateExamineCloseDate = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/examine`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateAdjustOnExamine = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/examine/adjust`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
const updateTransferOnExamine = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/examine/transfer`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
const updateRejectOnExamine = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/examine/reject`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateServiceRequestForInProgress = async (data, files) => {
    const formData = new FormData();
    files.forEach((file, index) => {formData.append(`files`, file.object);});
    formData.append("requestDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

    try {
        return await needAuth.put(
            `/serviceRequest/inProgress`, formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
            )
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
const updateInProgressDone = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/inProgress/done`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateServiceRequestForVerification = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/verification`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
const updateVerificationDone = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/verification/done`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateServiceRequestForFeedback = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/feedback`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
const updateFeedbackDone = async (data) => {
    try {
        return await needAuth.put(`/serviceRequest/feedback/done`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const deleteServiceRequest = async (id) => {
    try {
        return await needAuth.put(`/serviceRequest/delete/single`, id);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const deleteServiceRequests = async (ids) => {
    try {
        return await needAuth.put(`/serviceRequest/delete`, ids);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;

            handleActiveError({message: '서버에러'});
            return {status, data}
        }
    } finally {
        store.dispatch(apiLoading(false));
    }
}

export {
    selectServiceRequest,
    getServiceRequest,
    saveServiceRequest,
    updateServiceRequest,
    updateExamineCloseDate,
    updateServiceRequestForInProgress,
    updateServiceRequestForVerification,
    updateServiceRequestForFeedback,
    deleteServiceRequest,
    deleteServiceRequests,
    completePreRegisterWork,
    updateAdjustOnExamine,
    updateTransferOnExamine,
    updateRejectOnExamine,
    updateInProgressDone,
    updateVerificationDone,
    updateFeedbackDone
}